<div class="modal-content">
  <div class="container-fluid">
    <br /><br /><br /><br />
    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript: void(0);">Home</a></li>
              <li class="breadcrumb-item active">Dashboard</li>
            </ol>
          </div>
          <h4 class="page-title">User Audit</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->

    <div class="row" id="content" #content>
      <div class="col-12">
        Audit trail for Users
        <div class="card-box">
          <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped mb-0">
            <thead>
            <tr>
              <th style="width:5px;"> Id</th>
              <th style="width:80px"> Changed On </th>
              <th style="width:120px"> Changed By </th>
              <th style="width:50px"> Source </th>

              <th style="width:50px"> email </th>
              <th style="width:50px"> name </th>
              <th style="width:50px"> isActive </th>
              <th style="width:50px"> rolesAssigned </th>
              <th style="width:50px"> rolesRemoved </th>
              <th style="width:50px"> participantsAssigned </th>
              <th style="width:50px"> participantsRemoved </th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let log of auditLogs">
              <td style="font-size:12px"> {{ log.id }} </td>
              <td style="font-size:12px"> {{ log.changedOn | date:'MMMM d, y, h:mm:ss a' }} </td>
              <td style="font-size:12px"> {{ log.changedBy }} </td>
              <td style="font-size:12px"> {{ log.source }} </td>

              <td style="font-size:12px">{{log.email}}  </td>
              <td style="font-size:12px">{{log.name}}  </td>
              <td style="font-size:12px">{{log.isActive}}  </td>
              <td style="font-size:12px">{{log.rolesAssigned}}  </td>
              <td style="font-size:12px">{{log.rolesRemoved}}  </td>
              <td style="font-size:12px">{{log.participantsAssigned}}  </td>
              <td style="font-size:12px">{{log.participantsRemoved}}  </td>
            </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>
    <!-- end -->

  </div>
</div>
